$(function () {

	/**
	 * Menu/Header addons
	 */
	const $mainNavbar = $(".main-navbar");

	// Add hover effect to main nav
	$(".nav-item").each(function () {
		const $navItem = $(this);
		$navItem.children(".nav-link").hover(
			function () {
				$navItem.addClass('hover')
			},
			function () {
				$navItem.removeClass('hover')
			}
		);
	});

	// Add parent url, if child link is just a fragment like "#test"
	$mainNavbar.find(".nav-link").each(function () {
		const href = $(this).attr("href");
		if (href.match(/^#/)) {

			const parentHref = $(this).closest(".sub-menu").parent(".nav-item").children(".nav-link").attr("href");
			$(this).attr("href", parentHref + href);
		}
	});


	/**
	 * Submenu
	 */
	const $secondNavbarPlaceholder = $(".second-navbar-placeholder");
	const $mainMenu = $("#menu-main");

	// Create navbar from current active menu that can later be placed over the hero as tab-menu
	const $template = $mainMenu.children(".nav-item.current-page-ancestor, .nav-item.active").children(".sub-menu");
	const $secondNavbar = createSubmenu($template);
	$secondNavbarPlaceholder.append($secondNavbar);

	//
	// Create hover navbars for additional menus
	//
	$mainMenu.children(".nav-item").children(".nav-link").each(function () {

		// Add hover menu
		const $template = $(this).parent().children(".sub-menu");
		const $secondNavbarHover = createSubmenu($template);
		$secondNavbarHover.addClass("second-navbar-hover");
		$secondNavbarHover.hide();
		$secondNavbarPlaceholder.append($secondNavbarHover);
		// Save closingTimer to object
		$secondNavbarHover.data("closing-timer", null);

		const closeHoverMenuLazy = function () {
			// Set timer and hide the menu after n seconds
			clearTimeout($secondNavbarHover.data("closing-timer"));
			const closingTimer = setTimeout(function () {
				$secondNavbarHover.hide();
				// Show secondNavbar if not in Tab-mode
				if (!$secondNavbar.data("is-tabbar")) $secondNavbar.show();
			}, 600);
			// Save closingTimer to object
			$secondNavbarHover.data("closing-timer", closingTimer);
		};

		$(this).on("mouseenter", function () {
			// Remove all previous secondNavbars and timmers
			$secondNavbarPlaceholder.find(".second-navbar-hover").each(function () {
				$(this).hide();
				clearTimeout($(this).data("closing-timer"));
			});

			// Hide secondNavbar if not in Tab-mode
			if (!$secondNavbar.data("is-tabbar")) $secondNavbar.hide();

			$secondNavbarHover.show();
		});
		$(this).on("mouseleave", closeHoverMenuLazy);

		// Handle submenus
		$secondNavbarHover.on("mouseleave", closeHoverMenuLazy);
		$secondNavbarHover.on("mouseenter", function () {
			clearTimeout($secondNavbarHover.data("closing-timer"));
		});
	});


	// Place navbar as tabs over (the bottom of) the first hero element
	const $hero = $("main.container > .block-hero:first-child");
	const $elementAfterHero = $hero.next();
	if ($hero.length && !$("body").hasClass("dtg-second-navbar-prevent-tabbar") && !$elementAfterHero.hasClass("block-media-text-card")) {

		const $headerBg = $("header .header-bg");

		const placeSecondNavbarAsTabs = function () {

			const heroBottom = $hero[0].getBoundingClientRect().bottom;
			const secondNavbarHeight = 31;
			const headerHeight = $headerBg[0].getBoundingClientRect().bottom;

			if (heroBottom > (headerHeight + secondNavbarHeight)) {
				// Place over hero element
				$secondNavbar.css({"top": heroBottom - secondNavbarHeight});

				$secondNavbar.addClass("is-tabbar");
				$secondNavbar.data("is-tabbar", true);
			} else {
				$secondNavbar.removeClass("is-tabbar");
				$secondNavbar.data("is-tabbar", false);

				// Reset placing
				$secondNavbar.css({"top": 0});
			}
		};

		$(window).on("resize scroll", function () {
			placeSecondNavbarAsTabs();
		});
		setTimeout(function () {
			placeSecondNavbarAsTabs();
		}, 500);
		placeSecondNavbarAsTabs();
	}


	/**
	 * Create secondMenu
	 *
	 * @param $template
	 * @returns {jQuery|HTMLElement}
	 */
	function createSubmenu($template) {

		const $nav = $template.clone();
		$nav.removeClass("sub-menu").addClass("navbar-nav");

		// Create structure
		const $secondNavbarElement = $("<div class='second-navbar'>");
		const $secondNavbarBgElement = $("<div class='second-navbar-bg'>");
		const $secondNavbarContainerElement = $("<div class='second-navbar-container'>");
		const $secondNavbarNavElement = $("<div class='second-navbar-nav'>");
		const $secondNavbarSubnavElement = $("<div class='second-navbar-subnav'>");
		$secondNavbarElement.append($secondNavbarBgElement);
		$secondNavbarBgElement.append($secondNavbarContainerElement);
		$secondNavbarContainerElement.append($secondNavbarNavElement);
		$secondNavbarNavElement.append($secondNavbarSubnavElement);

		// Add main navigation to structure
		$secondNavbarNavElement.prepend($nav);

		const $navItems = $nav.children(".nav-item");
		const $submenus = $navItems.children(".sub-menu");

		$navItems.each(function () {
			const $item = $(this);
			const itemSubmenu = $item.children(".sub-menu");

			// Find ancestors and build breadcrumbs in tab menu
			let breadcrumbs = [];
			$item.find(".current-page-ancestor").each(function () {
				const navLink = $(this).children(".nav-link");
				breadcrumbs.push({
					href: navLink.prop("href"),
					text: navLink.text(),
					class: '',
				});
			});
			$item.find(".active").each(function () {
				const navLink = $(this).children(".nav-link");

				const href = navLink.prop("href");

				// Determine if link is onsite link
				let className = href.match(/#.*\/?$/) ? '' : 'active';

				breadcrumbs.push({
					href: href,
					text: navLink.text(),
					class: className,
				});
			});

			if (breadcrumbs.length) {
				// Wrap in nav-link
				const $link = $item.children(".nav-link");
				$link.removeClass("nav-link");
				$link.addClass("nav-link-breadcrumb");

				const $wrapper = $("<div class='nav-link'/>");
				$wrapper.append($link);

				for (let i = 0; i < breadcrumbs.length; i++) {
					let $breadcrumbLink = $("<a class='nav-link-breadcrumb'>");
					$breadcrumbLink.prop("href", breadcrumbs[i].href);
					$breadcrumbLink.addClass(breadcrumbs[i].class);
					$breadcrumbLink.text(breadcrumbs[i].text.replace(/^ ?» ?/g, ''));
					$wrapper.append($breadcrumbLink);
				}
				$item.prepend($wrapper);
			}

			// Remember link to submenu
			$item.data("submenu", itemSubmenu);

			// Move subnav to own container
			$secondNavbarSubnavElement.append(itemSubmenu);

			// Open submenu
			$(this).children(".nav-link").on("mouseenter touch", function () {
				$navItems.removeClass("opened");
				$item.addClass("opened");
				$submenus.removeClass("opened");
				itemSubmenu.addClass("opened");
			});
		});

		// Close submenu menu when mouse leaves
		$secondNavbarElement.on("mouseleave", function () {
			// $secondNavbarContainerElement.parent().parent().on("mouseleave", function () {
			$navItems.removeClass("opened");
			$submenus.removeClass("opened");
		});

		return $secondNavbarElement;
	}


	/**
	 * Mobile nav
	 */
	const $toggler = $(".navbar-toggler");
	const $thirdNavbar = $(".third-navbar");


	// Clone menu to mobile
	const $mobileNavbarContainer = $(".mobile-navbar-container");
	const $mobileNavbarBG = $(".mobile-navbar-bg");

	const $mobileMenu = $mainNavbar.clone();
	const $mobileThirdNavbar = $thirdNavbar.clone();

	const $placeholderElement = $(".mobile-navbar-placeholder");
	$placeholderElement.append($mobileMenu);
	$placeholderElement.append($mobileThirdNavbar);


	// Add toggle effect to toggler
	$toggler.on("click", function () {
		$toggler.toggleClass("opened");
		// $mobileNavbarBG.toggleClass("opened");
		$mobileNavbarBG.slideToggle();
	});


	// Add toggler to first and second nav trees
	$mobileNavbarContainer.find(".navbar-nav > .nav-item, .navbar-nav > .nav-item > .sub-menu > .nav-item").each(function () {
		const $item = $(this);
		const $subMenu = $(this).children(".sub-menu");

		// Return, if no children
		if (!$subMenu.length) {
			return;
		}

		const $subToggler = $("<div class='sub-toggler'>");
		$(this).prepend($subToggler);

		$subToggler.on("click", function (event) {
			$item.toggleClass("toggled");
			event.preventDefault();
			$subMenu.slideToggle();
		});

		// Hide children initially
		if (!$item.hasClass("current-page-ancestor")) {
			$subMenu.hide();
		} else {
			$item.addClass("toggled");
		}

	});


});



